import { EventEmitter } from '@angular/core';
import { BusinesLogicService } from '../../services/business-logic.service';
import { ModalHelper } from '../../components/modal/modal.helper';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
var DeskStatusComponent = (function () {
    function DeskStatusComponent(_blogic, _modal) {
        this._blogic = _blogic;
        this._modal = _modal;
        this.websocketError = new EventEmitter();
        this.withButton = false;
        this.desks = [];
        this.totalInOffice = 0;
        this.destroy$ = new Subject();
    }
    DeskStatusComponent.prototype.ngOnInit = function () {
        this.getDeskStatus();
    };
    DeskStatusComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    /* Get desk status */
    DeskStatusComponent.prototype.getDeskStatus = function () {
        var _this = this;
        this._blogic.getDeskInfo()
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this.desks = response;
        });
    };
    /* Open status modal */
    DeskStatusComponent.prototype.openStatusModal = function () {
        var _this = this;
        this._blogic.getDeskInfo()
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this.desks = response;
            _this._modal.show("deskStatusModal");
        });
    };
    return DeskStatusComponent;
}());
export { DeskStatusComponent };
